var _defs, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg50N(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 27.5,
    x2: 36.5,
    y1: 17.21,
    y2: 32.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4d7dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#d4d7dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bec1c6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    y1: 24.21,
    y2: 39.79,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    y1: 31.21,
    y2: 46.79,
    xlinkHref: "#a"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#a)",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M17 25h30"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "0s",
    dur: "5s",
    repeatCount: "indefinite",
    type: "translate",
    values: "-4 0; 4 0; -4 0"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#b)",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M17 32h30"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "-2s",
    dur: "5s",
    repeatCount: "indefinite",
    type: "translate",
    values: "-3 0; 3 0; -3 0"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#c)",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M17 39h30"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "-4s",
    dur: "5s",
    repeatCount: "indefinite",
    type: "translate",
    values: "-4 0; 4 0; -4 0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg50N);
export default __webpack_public_path__ + "static/media/50n.e61faee5b9692f9897af7717913dd7e3.svg";
export { ForwardRef as ReactComponent };